export enum CertificateInstrumentType {
  PMOZE_A = "PMOZE_A",
  PMOZE_BIO = "PMOZE-BIO",
  PMEF_F = "PMEF_F"
}

// export function toString();
// eslint-disable-next-line @typescript-eslint/no-namespace
namespace CertificateInstrumentTypeUtil {}
